var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoFix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13968_114985",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13968_114985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8312 5.11836L14.1937 3.76836L12.8438 3.14961L14.1937 2.51211L14.8312 1.16211L15.45 2.51211L16.8 3.14961L15.45 3.76836L14.8312 5.11836ZM6.39375 5.11836L5.75625 3.76836L4.40625 3.14961L5.75625 2.51211L6.39375 1.16211L7.0125 2.51211L8.3625 3.14961L7.0125 3.76836L6.39375 5.11836ZM14.8312 13.5559L14.1937 12.2059L12.8438 11.5871L14.1937 10.9496L14.8312 9.59961L15.45 10.9496L16.8 11.5871L15.45 12.2059L14.8312 13.5559ZM3.8625 15.8059L2.15625 14.1184C2.03125 13.9809 1.96875 13.8184 1.96875 13.6309C1.96875 13.4434 2.03125 13.2871 2.15625 13.1621L10.125 5.19336C10.2625 5.06836 10.425 5.00586 10.6125 5.00586C10.8 5.00586 10.9562 5.06836 11.0812 5.19336L12.7875 6.89961C12.9125 7.02461 12.975 7.18086 12.975 7.36836C12.975 7.55586 12.9125 7.71836 12.7875 7.85586L4.81875 15.8059C4.68125 15.9434 4.51875 16.0121 4.33125 16.0121C4.14375 16.0121 3.9875 15.9434 3.8625 15.8059ZM4.35 14.6996L9.7125 9.29961L8.6625 8.24961L3.2625 13.6309L4.35 14.6996Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFix);
export default __webpack_public_path__ + "static/media/auto_fix.20418dc5da433a0b04f949a815a9dfb1.svg";
export { ForwardRef as ReactComponent };